import React, { useEffect, useState } from 'react';
    import { motion } from 'framer-motion';
    import { useLocation } from 'react-router-dom';
    import Navigation from '../components/Navigation';
    import HeroSection from '../components/HeroSection';
    import EcosystemSection from '../components/EcosystemSection';
    import TransformationSection from '../components/TransformationSection';
    import AboutSection from '../components/AboutSection';
    import CTAFooter from '../components/CTAFooter';
    import CosmicBackground from '../components/CosmicBackground';

    const HomePage = () => {
      const [scrollY, setScrollY] = useState(0);
      const location = useLocation();

      useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);

      useEffect(() => {
        if (location.hash) {
          const id = location.hash.substring(1);
          setTimeout(() => {
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
        }
      }, [location]);

      return (
        <div className="min-h-screen bg-gray-900 text-white relative overflow-hidden">
          <CosmicBackground />
          <Navigation />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <HeroSection scrollY={scrollY} />
            <EcosystemSection />
            <TransformationSection />
            <AboutSection />
            <CTAFooter />
          </motion.div>
        </div>
      );
    };

    export default HomePage;